/* De Vergulde Kaars: homepage entrance reveal. Content is visible without JS. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function init() {
    var vh = window.innerHeight;
    document.querySelectorAll('.dvk-home-reveal:not(.dvk-reveal)').forEach(function (el) {
      // Leave anything already on screen alone so nothing flickers.
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      el.classList.add('dvk-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Product rails: keep the keyboard-focused card fully in view on narrow screens. */
(function () {
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var item = target.closest('.dvk-home-rail__item');
    if (!item) return;
    var track = item.parentElement;
    if (!track || track.scrollWidth <= track.clientWidth) return;
    var t = track.getBoundingClientRect();
    var r = item.getBoundingClientRect();
    if (r.left >= t.left - 1 && r.right <= t.right + 1) return;
    var pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart) || 0;
    track.scrollTo({ left: track.scrollLeft + (r.left - t.left) - pad, behavior: 'auto' });
  });
})();

/* Hero quick-link rail: fade the trailing edge only while more chips are hidden. */
(function () {
  function update(rail) {
    var more = rail.scrollWidth - rail.clientWidth - rail.scrollLeft > 4;
    rail.classList.toggle('has-more', more);
  }

  function init() {
    document.querySelectorAll('.dvk-hero__rail').forEach(function (rail) {
      update(rail);
      rail.addEventListener('scroll', function () { update(rail); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { update(rail); }).observe(rail);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
